export default __webpack_public_path__ + "static/media/logo-light.147b2469.png";